"use client";
const o = (t) => t ? "true" : void 0;
export {
  o as dataBooleanAttr
};
